class FindAnOfficeSearch {
    constructor() {
        this.form = document.querySelector(".js-find-an-office-search-form");
        this.searchInput = document.querySelectorAll(".js-find-an-office-search-input");
        this.searchSubmit = document.querySelectorAll(".js-find-an-office-search-submit");
    }

    watchSearch() {
        const { form, searchInput, searchSubmit} = this;
        if (searchSubmit) {
            // wait until input has a value to enable submit button
            searchInput.forEach(input => {
                input.addEventListener("keydown", () => {
                    searchSubmit.forEach(submit => {
                        setTimeout(function() {
                            if (input.value) {
                                submit.removeAttribute("disabled");
                            } else {
                                submit.setAttribute("disabled", "disabled");
                            }
                        }, 200);
                    });
                });
            });
        } else if (form) {
            // if no submit button, disable form submit (input used to trigger map update)
            form.addEventListener('submit', (e) => {
                e.preventDefault();
            });
        }
    }

    init() {
        this.watchSearch();
    }
}

export default FindAnOfficeSearch;



// WEBPACK FOOTER //
// ../project/craft/src/components/find-an-office-search/find-an-office-search.js